import { Loadable } from 'components/common';
import { useOmniHistoriesLeadManageContext } from 'contexts';
import { twMerge } from 'tailwind-merge';
import { ChatSessionDto } from 'types';
import OmniChannelLeadChatOngoingList from 'components/omni-channel-chat-histories/OmniChannelLeadChatOngoingList';
import OngoingChatDetails from './OngoingChatDetails';
import { OmniChannelLeadChatHistoriesChatBox } from 'components/omni-channel-chat-histories';

type OngoingChatManagementTabProps = {
  onSelectCustomer?: (value?: ChatSessionDto) => void;
  selectedCustomerId?: number;
};

const OngoingChatManagementTab: React.FC<OngoingChatManagementTabProps> = ({
  onSelectCustomer,
  selectedCustomerId
}) => {
  const { chatOngoing } = useOmniHistoriesLeadManageContext();

  return (
    <div className='flex h-full flex-1'>
      <div className={twMerge('mx-auto h-full w-[360px] shrink-0 2xl:w-[468px]', chatOngoing ? '' : 'border-x')}>
        <OmniChannelLeadChatOngoingList />
      </div>
      {chatOngoing && (
        <div
          className={twMerge(
            'h-full w-full border-r transition-all duration-200',
            chatOngoing ? '-translate-x-0' : 'translate-x-full'
          )}
        >
          <Loadable>
            <OmniChannelLeadChatHistoriesChatBox chatSession={chatOngoing} />
          </Loadable>
        </div>
      )}
      {chatOngoing && (
        <div
          className={twMerge(
            'h-full w-[360px] shrink-0 rounded-xl bg-white transition-all duration-200 2xl:w-[468px]',
            chatOngoing ? 'translate-x-0' : 'translate-x-full'
          )}
        >
          <OngoingChatDetails />
        </div>
      )}
    </div>
  );
};

export default OngoingChatManagementTab;
